import { MemberDependent } from '@interfaces/member-dependent.model';
import { createAction, props } from '@ngrx/store';

export enum activeMemberActionTypes {
  setActiveMemberState = '[SET] Set Active Member State',
  setMemberCountState = '[SET] Set Member Count State',
}

export const setActiveMemberStateAction = createAction(
  activeMemberActionTypes.setActiveMemberState,
  props<{ member: MemberDependent }>()
);

export const setMemberCountStateAction = createAction(
  activeMemberActionTypes.setMemberCountState,
  props<{ memberCount: number }>()
);
